var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.684,17.912 C12.408,18.885 13.592,18.885 14.316,17.912 L19.455,11.007 C20.179,10.034 19.784,9.238 18.578,9.238 L14.096,9.238 L14.096,-0.000 L11.904,-0.000 L11.904,9.238 L7.422,9.238 C6.216,9.238 5.821,10.034 6.545,11.007 L11.684,17.912 ZM24.904,13.979 C24.299,13.979 23.808,14.474 23.808,15.084 L23.808,23.684 C23.808,24.293 23.315,24.790 22.711,24.790 L3.288,24.790 C2.685,24.790 2.192,24.293 2.192,23.684 L2.192,15.186 C2.192,14.576 1.701,14.081 1.096,14.081 C0.491,14.081 -0.000,14.576 -0.000,15.186 L-0.000,23.684 C-0.000,25.512 1.475,27.000 3.288,27.000 L22.711,27.000 C24.525,27.000 26.000,25.512 26.000,23.684 L26.000,15.084 C26.000,14.474 25.509,13.979 24.904,13.979 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportFile);
export default __webpack_public_path__ + "static/media/importFile.616691b2.svg";
export { ForwardRef as ReactComponent };